import { NonAccrualStatusIndicator } from './NonAccrualStatusIndicator';

export const NonAccrualStatusDescriptions:Map<NonAccrualStatusIndicator, string> = new Map([
  [NonAccrualStatusIndicator.NON_ACCRUAL_DATE, 'Non Accrual Date'],
  [NonAccrualStatusIndicator.STATUS_CODE, 'Status Code'],
  [NonAccrualStatusIndicator.PRODUCT_CODE, 'Product Code'],
  [NonAccrualStatusIndicator.STATUS_CODE_AND_PRODUCT_CODE, 'Status Code AND Product Code'],
  [NonAccrualStatusIndicator.STATUS_CODE_OR_PRODUCT_CODE, 'Status Code OR Product Code'],
  [NonAccrualStatusIndicator.STATUS_CODE_AND_NON_ACCRUAL_DATE, 'Status Code AND Non Accrual Date'],
  [NonAccrualStatusIndicator.STATUS_CODE_OR_NON_ACCRUAL_DATE, 'Status Code OR Non Accrual Date'],
  [NonAccrualStatusIndicator.PRODUCT_CODE_AND_NON_ACCRUAL_DATE, 'Product Code AND Non Accrual Date'],
  [NonAccrualStatusIndicator.PRODUCT_CODE_OR_NON_ACCRUAL_DATE, 'Product Code OR Non Accrual Date'],
  [NonAccrualStatusIndicator.STATUS_CODE_AND_PRODUCT_CODE_AND_NON_ACCRUAL_DATE, 'Status Code AND Product Code AND Non Accrual Date'],
  [NonAccrualStatusIndicator.STATUS_CODE_OR_PRODUCT_CODE_OR_NON_ACCRUAL_DATE, 'Status Code OR Product Code OR Non Accrual Date'],
]);

export default NonAccrualStatusDescriptions;
